import { get } from "lodash-es"
import React from "react"

/*
entityProps - Props that you get from FormController
props - Props that you get from the individual components like StringInput

*/
const FormControllerContext = React.createContext({})
export function withFormController(Component: React.FC | any) {
  return function FormControllerComponent(componentProps: any) {
    return (
      <FormControllerContext.Consumer>
        {formControllerProps => {
          const path = get(componentProps, "path")
          const source = get(formControllerProps, "source", null)
          const errors = get(formControllerProps, "errors", {})
          const sourceValue = get(source, path)
          const sourceError = get(errors, path)
          const disabled = get(formControllerProps, "disabled", false)
          const disableAll = get(formControllerProps, "disableAll", false)

          const newProps = {
            source,
            disabled: componentProps.disabled
              ? true
              : componentProps.protectedInput && disabled
              ? true
              : disableAll && disabled
              ? true
              : false,
            value:
              typeof componentProps.value !== "undefined"
                ? componentProps.value
                : sourceValue,
            error: componentProps.error || sourceError,
            onChange: componentProps.onChange
              ? componentProps.onChange
              : get(formControllerProps, "onChange", componentProps.onChange),
            onAdd: get(formControllerProps, "onAdd", null),
            onRemove: get(formControllerProps, "onRemove", null),
          }

          return <Component {...componentProps} {...newProps} />
        }}
      </FormControllerContext.Consumer>
    )
  }
}

export interface FormControllerProps<Source = any, Errors = object> {
  /*
    Source: The object which contains the entire data for the form
    eg. {
      firstName:"xyz",
      lastName:"abc",
      groups:[1,2,3]
    }
  */
  source: Source
  /*
    Errors: the errors object,(note the schema must match the shape of the source object)
    eg.
    source - {firstName:"xyz"}, errors - {firstName:"First name is too short"}
  */
  errors?: Errors
  /*
    Disabled: This boolean disables all the children inside the form only if are protected
  */
  disabled?: boolean
  /*
    disableAll: This boolean disables all the children inside the form regardless of whether they are prtotected or not!
  */
  disableAll?: boolean
  /*
    onChange: This function has two positional parameters 1. the path (string) where the data has changed, value
  */
  onChange: (path: string, value: any) => void
  /*
    onAdd: This function has two positional parameters 1. the path(mostly array) where the data needs to added,
    and the new value(mostly object) that needs to be added
  */
  onAdd?: (path: any, value: any) => void
  /*
    onRemove: This function has 1 positional parameter, the path(mostly array) where the data needs to removed,
  */
  onRemove?: (path: any, index?: any) => void
  children?: React.ReactNode
}
const FormController = ({
  children,
  ...controllerProps
}: FormControllerProps) => {
  return (
    <FormControllerContext.Provider
      value={{
        ...controllerProps,
      }}
    >
      {children}
    </FormControllerContext.Provider>
  )
}

export default FormController
